import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { RoleService } from '../../@core/services/role.service';
import { ExportService } from '../../@core/services/export.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-part-info',
  templateUrl: './part-info.component.html',
  styleUrls: ['./part-info.component.scss']
})
export class PartInfoComponent implements OnInit {
  makeName: string = 'Select Make';

  makeDetails = [
    { id: 1, makeName: 'AMP' },
    { id: 2, makeName: 'TE Connectivity' },
    { id: 3, makeName: 'AERO' },
    { id: 4, makeName: 'Rotary' },
    { id: 5, makeName: 'ITT' },
  ];

  selectedManufacturer: string = "";
  filteredSourceInfoData: any[] = [];
  selectedRowIndex: number | null = null;
  modalRef: NgbModalRef | null = null;
  fromPoHistory: boolean = false;


  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  // selectedPriceData: any;

  selectedPriceData: any = null;

  sourceInfoData: any[] = [];
  project_id: any;
  projectName: any;
  version_id!: number;
  userId: any;
  role: any;
  userRole: any;
  projectViewData = [];
  errorMessage: string = '';
  internalPartNo: any;
  rankedSellersDetails: any[] = [];
  manufacturerDetails = [];
  part_header = [];
  // projectQty = [];
  projectQty: number = 0;
  description: any;
  dataSheet: any;
  selectedRow: number | null = null;
  MPN: any;
  mpnMatch: string = '';
  sessionMpnMatch: string = '';
  closeResult: string = '';
  offerPriceListDetails: any[] = [];
  projectSupplierName: string = "";
  customerName: string = '';
  // selectedPriceRowIndex: number | null;
  selectedPriceRowIndex: number | null = null;


  customerInfoData: any;
  leadTimeFromHeader: number | null = null;
  commidityFromHeader: any;
  commodity: any; // <-- Add this line to declare the property
  criteria: any = {}
  preparedPartDetails: any[] = [];
  preparedQuery: string = '';

  isLoadingIpnInfo: boolean = false;
  isLoading: boolean = false;
  loadingTitle: string = 'Loading Part Intelligence';
  loadingSubtitle: string = 'Retrieving parts, Top-N sellers, and benchmark pricing...';
  ipnInfoRelationships: any[] = [];
  ipnInfoMpnCount: number = 0;
  ipnInfoMfgCount: number = 0;


  showSpecsDetails = false;
  selectedSpecs: any[] = [];
  selectedPart: any = null;
  selectedPartDetails: any = {};
  cleanedResHTML: string = '';
  showPopup = false;
  showPopup1 = false;
  showAlternatePopup = false;
  alternateResHTML: string = '';

  // Alternatives popup properties
  showAlternativesPopup = false;
  alternativesData: any = null;
  selectedPartForAlternatives: any = null;
  selectedSupplierData: any;
  projectStatus: string = '';
  approvalStatus: string = '';
  get isReviewStage(): boolean {
    const status = (this.approvalStatus || '').toLowerCase().trim();
    return status === 'pending - manager review' || status === 'approved';
  }
  cameFrom: string = 'part-info';



  savedFilter: string = 'all';

  @ViewChild('addPartModal') addPartModal: any;
  @ViewChild('offlineConfirmModal') offlineConfirmModal: any;
  partForm!: FormGroup;
  // frequencyOptions: any[] = [];
  frequencyOptions: { id: number, scheduleType: string }[] = [];
  activeModal!: NgbModalRef;
  offlineConfirmModalRef!: NgbModalRef; // Add this line
  tempOfflineData: any; // Add this to store offline data temporarily
  ngOnInit() {
    this.project_id = sessionStorage.getItem('project_id');
    this.version_id = Number(sessionStorage.getItem('version_id'));
    this.projectName = sessionStorage.getItem('projectName');
    this.internalPartNo = String(sessionStorage.getItem('internalPartNo'));
    this.mpnMatch = String(sessionStorage.getItem('mpnMatch'));
    this.sessionMpnMatch = String(sessionStorage.getItem('mpnMatch'));
    this.commodity = String(sessionStorage.getItem('commodity') || '');



    this.projectStatus = sessionStorage.getItem('projectStatus') || '';


    // projectSupplierInfo
    console.log('version_id:', this.version_id);


    this.userId = sessionStorage.getItem('user_id'); // Retrieves session user_id
    this.role = sessionStorage.getItem('role');     // Retrieves role   
    console.log('User ID:', this.userId);
    console.log('Role:', this.role);


    let projectSupplierInfo = JSON.parse(sessionStorage.getItem('projectSupplierInfo') || '{}');

    this.projectSupplierName = projectSupplierInfo?.supplier || '';
    this.commodity = projectSupplierInfo?.commodity || '';

    console.log("Commodity from projectSupplierInfo:", this.commodity);

    console.log('projectSupplierInfo', projectSupplierInfo)

    const navData: any = this.location.getState();
    if (navData?.internalPartNo) {
      this.fromPoHistory = true;
      this.internalPartNo = navData.internalPartNo;
      this.projectQty = navData.projectQty;
    }
    this.getdata();
    this.userRole = this.roleService.getUserRole();
    this.partForm = this.f_builder.group({
      projectName: ['', Validators.required],
      internalPartNo: ['', Validators.required],
      MPN: ['', Validators.required],
      Make: [''],
      uom: ['', Validators.required],
      requiredQuantity: ['', [Validators.required, Validators.min(1)]],
      frequency: [null, Validators.required]
    });
    this.onSort(this.sortColumn);
    if (this.fromPoHistory) {
      this.getProcurementHistory();
    }
    if (navData?.fromProjectView) {
      this.cameFrom = 'project-view';
    }
    // this.savePriceData();
  }
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private roleService: RoleService,
    private notify: NbToastrService,
    private exportService: ExportService,
    private actRoute: ActivatedRoute,
    private f_builder: FormBuilder,
    private location: Location
  ) {
    const navigation = this.router.getCurrentNavigation();
    console.log("navigation => ", navigation)
    if (navigation?.extras?.state) {
      this.customerInfoData = navigation.extras.state.customerInfo;
      let row = navigation.extras.state.row
      this.savedFilter = navigation.extras.state.savedFilter || sessionStorage.getItem('projectViewFilter') || 'all';

      console.log("Received Filter From Project-View:", this.savedFilter);

      if (navigation.extras.state.fromProjectView) {
        this.cameFrom = 'project-view';
      } else {
        this.cameFrom = 'part-info';
      }
    }

    this.approvalStatus = this.customerInfoData?.approval_status || sessionStorage.getItem('approval_status') || '';
    if (this.approvalStatus) {
      sessionStorage.setItem('approval_status', this.approvalStatus);
    }


  }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredSourceInfoData.sort((a, b) => {
      const rawA = this.getSortValue(a, column);
      const rawB = this.getSortValue(b, column);

      // Handle null/undefined/empty string - keep empty values at the bottom
      const isAEmpty = rawA === null || rawA === undefined || rawA === '';
      const isBEmpty = rawB === null || rawB === undefined || rawB === '';

      if (isAEmpty && isBEmpty) return 0;
      if (isAEmpty) return 1;
      if (isBEmpty) return -1;

      // Check if values are numbers
      const numA = Number(rawA);
      const numB = Number(rawB);
      const isNumber = !isNaN(numA) && !isNaN(numB);

      if (isNumber) {
        return this.sortDirection === 'asc'
          ? numA - numB
          : numB - numA;
      }

      const strA = rawA.toString().trim().toLowerCase();
      const strB = rawB.toString().trim().toLowerCase();

      return this.sortDirection === 'asc'
        ? strA.localeCompare(strB)
        : strB.localeCompare(strA);
    });
  }

  private getSortValue(item: any, column: string): any {
    if (!item) return null;

    if (column === 'Closest Quantity' || column === 'Closest_Quantity') {
      return item.Closest_Quantity ?? item['Closest Quantity'];
    }
    if (column === 'leadTime' || column === 'estimatedFactoryLeadDays') {
      return item.estimatedFactoryLeadDays ?? item.leadTime;
    }
    if (column === 'Landing_cost' || column === 'LandingCost') {
      return item.LandingCost ?? item.Landing_cost ?? item.landing_cost;
    }

    return item[column];
  }

  getSortIcon(column: string) {
    if (this.sortColumn !== column) {
      const isMatch = (
        (column === 'Closest Quantity' || column === 'Closest_Quantity') &&
        (this.sortColumn === 'Closest Quantity' || this.sortColumn === 'Closest_Quantity')
      ) || (
        (column === 'leadTime' || column === 'estimatedFactoryLeadDays') &&
        (this.sortColumn === 'leadTime' || this.sortColumn === 'estimatedFactoryLeadDays')
      ) || (
        (column === 'Landing_cost' || column === 'LandingCost') &&
        (this.sortColumn === 'Landing_cost' || this.sortColumn === 'LandingCost')
      );
      if (!isMatch) {
        return 'fa fa-sort'; // Default unsorted icon
      }
    }
    return this.sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
  }

  openAddPartModal() {
    this.activeModal = this.modalService.open(this.addPartModal, { size: 'xl' });
    this.getProjectPartDetails();
    this.getFrequencyOptions();


    this.partForm.get('projectName')?.disable();
    this.partForm.get('internalPartNo')?.disable();
    this.partForm.get('MPN')?.disable();
    this.partForm.get('uom')?.disable();
    this.partForm.get('requiredQuantity')?.disable();
    this.partForm.get('frequency')?.enable();
  }

  specification: string = '';


  // getProjectPartDetails() {
  //   const data = {
  //     project_id: this.project_id,
  //     version_id: this.version_id,
  //     internalPartNo: this.internalPartNo
  //   };

  //   this.masterService.get_project_part_details_Top_N_Seller(data).subscribe((res: any) => {
  //     if (res?.results?.length > 0) {
  //       const partDetails = res.results[0].project_parts[0].part_details[0];
  //       const nexarOffers = partDetails.Top_N_Sellers.nexar || [];

  //       const offlineOffers = partDetails.Top_N_Sellers.offline || [];
  //       const vendorOffers = partDetails.Top_N_Sellers.vendor || [];


  //       const tableData = [];

  //       // Add nexar data with sourcingType = 'nexar'
  //       for (const offer of nexarOffers) {
  //         tableData.push({ ...offer, sourcingType: 'nexar' });
  //       }

  //       // Add offline data with sourcingType = 'offline'
  //       for (const offer of offlineOffers) {
  //         tableData.push({ ...offer, sourcingType: 'offline' });
  //       }
  //       for (const offer of vendorOffers) {
  //         tableData.push({ ...offer, sourcingType: 'vendor' });
  //       }

  //       // Set combined data for your table
  //       this.filteredSourceInfoData = tableData;

  //       // Patch other form values if needed
  //       const project = res.results[0].project;
  //       const partHeader = res.results[0].project_parts[0].part_header;


  //       // Extract first Nexar offer if exists
  //       const firstNexarOffer = partDetails.Top_N_Sellers.nexar?.[0] || {};
  //       this.specification = firstNexarOffer.specification || '';
  //       console.log("specification =>", this.specification)
  //       if (project && partHeader) {

  //         this.partForm.patchValue({
  //           projectName: res.results[0].project.projectName || '',
  //           internalPartNo: res.results[0].project_parts[0].part_header.internalPartNo || '',
  //           MPN: firstNexarOffer.MPN || '',
  //           Make: firstNexarOffer.manufacturer || '',  // Patch Make from manufacturer field
  //           uom: res.results[0].project_parts[0].part_header.uom || '',
  //           requiredQuantity: res.results[0].project_parts[0].part_header.projectQty || '',
  //           specification: firstNexarOffer.specification || '',


  //         });

  //       }
  //     }
  //   }, error => {
  //     console.error("Failed to load part data", error);
  //   });
  // }

  getProjectPartDetails() {
    const data = {
      project_id: this.project_id,
      version_id: this.version_id,
      internalPartNo: this.internalPartNo,
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
    };

    this.isLoading = true;
    this.loadingTitle = 'Loading Part Intelligence';
    this.loadingSubtitle = 'Fetching Top-N sellers, pricing, and part specifications...';
    this.masterService.get_project_part_details_Top_N_Seller(data).subscribe((res: any) => {
      this.isLoading = false;
      if (res?.results?.length > 0) {
        // Extract customerName from API response
        const result = res.results[0];
        this.customerName = result?.project?.customerName || result?.project?.customer_name || result?.customerName || result?.customer_name || '';
        console.log('CustomerName from getProjectPartDetails API:', this.customerName);

        const projectParts = res.results[0].project_parts[0];
        const partDetails = projectParts.part_details[0];
        const partHeader = projectParts.part_header;

        //  IMPORTANT: projectQty set before calculation
        this.projectQty = partHeader?.projectQty || 0;

        const nexarOffers = partDetails.Top_N_Sellers.nexar || [];
        const offlineOffers = partDetails.Top_N_Sellers.offline || [];
        const vendorOffers = partDetails.Top_N_Sellers.vendor || [];

        let tableData: any[] = [];

        // Nexar
        nexarOffers.forEach((offer: any) => {
          tableData.push({ ...offer, sourcingType: 'nexar' });
        });

        // Offline
        offlineOffers.forEach((offer: any) => {
          tableData.push({ ...offer, sourcingType: 'offline' });
        });

        // Vendor
        vendorOffers.forEach((offer: any) => {
          tableData.push({ ...offer, sourcingType: 'vendor' });
        });

        //  APPLY LANDING COST CALCULATION HERE
        this.filteredSourceInfoData = this.calculateLandingCosts(tableData);

        // ---- Form patching ----
        const firstNexarOffer = nexarOffers?.[0] || {};
        const firstOfflineOffer = offlineOffers?.[0] || {};
        const firstVendorOffer = vendorOffers?.[0] || {};
        const firstOffer = nexarOffers.length > 0 ? firstNexarOffer
          : offlineOffers.length > 0 ? firstOfflineOffer
            : firstVendorOffer;

        this.specification = firstOffer.specification || '';

        this.partForm.patchValue({
          projectName: res.results[0].project?.projectName || '',
          internalPartNo: partHeader?.internalPartNo || '',
          MPN: firstOffer.MPN || '',
          Make: firstOffer.manufacturer || '',
          uom: partHeader?.uom || '',
          requiredQuantity: partHeader?.projectQty || '',
          specification: this.specification
        });

        console.log('Final Modal Data:', this.filteredSourceInfoData);
      } else {
        console.error('No data available for part details');
        this.notify.danger('No data available for this part', 'Error');
        if (this.activeModal) {
          this.activeModal.close();
        }
      }
    }, error => {
      this.isLoading = false;
      console.error("Failed to load part data", error);
      this.notify.danger('Failed to load part details. Please try again.', 'Error');
      if (this.activeModal) {
        this.activeModal.close();
      }
    });
  }



  getFrequencyOptions() {
    this.masterService.get_frequency().subscribe({
      next: (res) => {
        if (Array.isArray(res)) {
          this.frequencyOptions = res;
        }
      },
      error: (err) => {
        console.error("Error loading frequency options", err);
      }
    });
  }

  submitAddPart() {
    if (this.partForm.invalid) return;
    const newPart = this.partForm.getRawValue();
    const currentUser = JSON.parse(JSON.stringify(sessionStorage.getItem('userDetails')));
    const job_id = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);

    const partPayload = {
      project_id: Number(this.project_id),
      project_name: newPart.projectName || `TP-${this.project_id}`,
      version_id: String(this.version_id),  // FIX: keep it number
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
      job_id: job_id,
      internal_part_no: newPart.internalPartNo,
      mpn: newPart.MPN,
      uom: newPart.uom,
      project_qty: Number(newPart.requiredQuantity) || 0,
      frequency_id: Number(newPart.frequency?.id) || 0,  // FIX: number not string
      sourcing_type: ['vendor'],

      data: [
        {
          part_header: {
            internalPartNo: newPart.internalPartNo,
            customerPartNumber: newPart.customerPartNumber || "",
            description: newPart.description || "",
            commodity: newPart.commodity || "",
            mpn: newPart.MPN,
            uom: newPart.uom,
            projectQty: Number(newPart.requiredQuantity) || 0,
            iSourcing: "No",
            stockAvailability: 0,
            leadTime: 0,
            minimumPrice: 0,
            authorisedSuppliers: 0,
            suppliers: [],
            eau: 0
          },
          Parts: [
            {
              specification: newPart.MPN || "",

              manufacturer:
                newPart.Make && newPart.Make !== 'N/A' ? newPart.Make : 'undefined'
            }
          ]

        }
      ]

    };



    console.log('Submitting part payload:', partPayload);


    this.masterService.create_part_alert(partPayload).subscribe(
      (res: any) => {
        alert('Part created successfully!');
        this.activeModal.close();
      },
      (error) => {
        console.error("Error creating part:", error);
        alert('Error while creating part.');
      }
    );
  }






  getdata() {
    this.sourceInfoData = [];
    this.rankedSellersDetails = [];
    let data = {
      "project_id": Number(this.project_id),
      "version_id": Number(this.version_id),
      "procurement_version_id": this.customerInfoData?.procurement_version_id ?? 0,
      "internalPartNo": String(this.internalPartNo),
    };

    console.log('data', data, this.internalPartNo);
    this.isLoading = true;
    this.loadingTitle = 'Loading Part Intelligence';
    this.loadingSubtitle = 'Analyzing quotes, seller rankings, and procurement data...';
    this.masterService.get_project_part_details_Top_N_Seller(data).subscribe((result: any) => {
      this.isLoading = false;
      let message = result['message'];
      let data = result['results'];
      console.log('results', result);

      // Extract customerName from API response
      if (result?.results && result.results.length > 0) {
        const resultObj = result.results[0];
        this.customerName = resultObj?.project?.customerName || resultObj?.project?.customer_name || resultObj?.customerName || resultObj?.customer_name || '';
        console.log('CustomerName from getdata API:', this.customerName);
      }

      if (data && data.length > 0) {
        const project_parts = data[0]?.project_parts;
        console.log('project_parts', project_parts);

        this.projectViewData = project_parts[0].part_details;
        let part_header = project_parts[0].part_header;
        this.part_header = part_header;
        this.criteria = {
          stockAvailability: part_header.stockAvailability === 1,
          leadTime: part_header.leadTime === 1,
          minimumPrice: part_header.minimumPrice === 1,
          authorisedSuppliers: part_header.authorisedSuppliers === 1,
          selectedSuppliers: part_header.suppliers || []
        };
        this.projectQty = part_header?.projectQty;
        this.description = part_header?.description;
        this.leadTimeFromHeader = part_header?.leadTime;
        this.commidityFromHeader = part_header?.commodity;

        // Combine nexar and offline offers and add sourcingType for each
        let combinedOffers: any[] = [];
        const partDetails = data[0].project_parts[0].part_details || [];

        const firstDetail = partDetails?.[0];
        const firstNexarOffer = firstDetail?.Top_N_Sellers?.nexar?.[0];
        const firstOfflineOffer = firstDetail?.Top_N_Sellers?.offline?.[0];
        const firstVendorOffer = firstDetail?.Top_N_Sellers?.vendor?.[0];

        this.specification = firstNexarOffer?.specification
          || firstOfflineOffer?.specification
          || firstVendorOffer?.specification
          || '';

        partDetails.forEach((detail: any) => {
          const onlineOffers = detail.Top_N_Sellers?.nexar || [];
          onlineOffers.forEach((offer: any) => {
            combinedOffers.push({ ...offer, sourcingType: 'nexar' });
          });

          const offlineOffers = detail.Top_N_Sellers?.offline || [];
          offlineOffers.forEach((offer: any) => {
            combinedOffers.push({ ...offer, sourcingType: 'offline' });
          });
          const vendorOffers = detail.Top_N_Sellers?.vendor || [];
          vendorOffers.forEach((offer: any) => {
            combinedOffers.push({ ...offer, sourcingType: 'vendor' });
          });

        });

        // this.sourceInfoData = combinedOffers;
        // this.filteredSourceInfoData = combinedOffers;
        this.sourceInfoData = combinedOffers;        // original
        this.filteredSourceInfoData = [...combinedOffers];

        this.filteredSourceInfoData = this.calculateLandingCosts(this.sourceInfoData);

        let PartInfoDetails = JSON.parse(JSON.stringify(data[0].project_parts[0].part_details));

        let d: any = PartInfoDetails.map((r: any) => {
          delete r.Specs;
          return r;
        });

        this.preparedPartDetails = d
        // this.preparedQuery = "Perform a supplier-wise risk assessment and return a table only (no explanation) with columns: Supplier Name, Total Risk Score (out of 10, 1 decimal), and individual contributions from Inventory Risk (25%), Lead Time Risk (20%), Authorization Risk (25%), Price Deviation Risk (15%), Geographic Risk (15%); calculate: (1) Inventory Risk: InventoryLevel >> ProjectQty = Very Low Risk, > ProjectQty = Low Risk, < ProjectQty = High Risk; (2) Lead Time Risk: factoryLeadDays >12 or (0 and estFactoryLeadDays >12) = High Risk, <8 = Low Risk, (0 and <8) = Medium Risk, both 0 = Very High Risk; (3) Authorization Risk: authorized = Low, not authorized = High; (4) Price Deviation: higher deviation from lowest ConvertedPrice = higher risk; (5) Geographic Risk: US/Europe = Low, Singapore/Australia/etc = Medium, China/Israel/APAC = High; (6) Authorized Supplier Count Risk: fewer authorized suppliers = higher risk; output format must be exact: | Supplier Name | Total Risk Score | Inventory Risk | Lead Time Risk | Authorization Risk | Price Deviation Risk | Geographic Risk |.i want table border='1' in table element ";
        this.preparedQuery = `# Procurement Supplier Risk Assessment & Dashboard Generation

You are an expert Procurement Risk Assessment Engine and UI Generator for an Electronics Supply Chain platform.

Your responsibilities are:

1. Calculate procurement risk accurately using the defined business rules.
2. Present the results in a professional, clean, and responsive HTML table.
3. Highlight high-risk suppliers visually.
4. Explain why a supplier has a high risk score.
5. Return ONLY valid HTML. Do not use Markdown or provide explanations outside the HTML.

---

# Objective

Calculate an Overall Procurement Risk Score for every supplier.

Risk Score Range

* **0 = No Risk**
* **10 = Extreme Risk**

The final score MUST always be calculated as a weighted average.

Never estimate the final score directly.

Always calculate every risk category first.

Round the final score to one decimal place.

Never return values below 0 or above 10.

---

# Risk Weightage

| Risk Category      | Weight |
| ------------------ | ------ |
| Inventory Risk     | 25%    |
| Lead Time Risk     | 20%    |
| Authorization Risk | 25%    |
| Price Risk         | 15%    |
| Geographic Risk    | 15%    |

Overall Risk Score

= (Inventory × 0.25)

* (Lead Time × 0.20)

* (Authorization × 0.25)

* (Price × 0.15)

* (Geographic × 0.15)

---

# Step 1 - Inventory Risk

Compare InventoryLevel with ProjectQty.

Inventory ≥ 5 × ProjectQty

Risk = 0

Inventory ≥ 2 × ProjectQty

Risk = 2

Inventory ≥ ProjectQty

Risk = 4

Inventory ≥ 50% of ProjectQty

Risk = 6

Inventory > 0 but < 50% of ProjectQty

Risk = 8

Inventory = 0

Risk = 10

---

# Step 2 - Lead Time Risk

Use factoryLeadDays.

If factoryLeadDays is unavailable or zero, use estFactoryLeadDays.

Lead Time ≤ 7 days

Risk = 0

8–14 days

Risk = 3

15–28 days

Risk = 6

29–42 days

Risk = 8

> 42 days

Risk = 10

If both values are unavailable

Risk = 7

---

# Step 3 - Authorization Risk

Authorized Distributor

Risk = 0

Non-Authorized Distributor

Risk = 10

---

# Step 4 - Price Risk

Find the lowest ConvertedPrice among all suppliers.

Calculate

Price Deviation %

=((Supplier Price − Lowest Price) / Lowest Price) × 100

Assign risk

Lowest Price

Risk = 0

0–5%

Risk = 1

5–10%

Risk = 3

10–20%

Risk = 5

20–40%

Risk = 7

> 40%

Risk = 10

---

# Step 5 - Geographic Risk

Low Risk Countries

USA

Canada

Germany

United Kingdom

France

Japan

South Korea

Taiwan

Risk = 2

Medium Risk Countries

India

Singapore

Malaysia

Thailand

Vietnam

Mexico

Risk = 5

High Risk Countries

China

Hong Kong

Risk = 8

Countries under sanctions or severe export restrictions

Risk = 10

---

# Step 6 - Calculate Overall Risk

Calculate all five category scores.

Multiply each score by its corresponding weight.

Add the weighted values.

Round to one decimal place.

Do NOT manually estimate the final score.

---

# Step 7 - Determine Risk Level

0.0 – 2.0

Very Low Risk

2.1 – 4.0

Low Risk

4.1 – 6.0

Medium Risk

6.1 – 8.0

High Risk

8.1 – 10.0

Critical Risk

---

# Step 8 - Generate Risk Reason

Generate a concise reason (maximum 25 words).

Mention only the major contributors to the risk.

Examples

"Limited inventory and higher-than-average pricing."

"Long lead time and unauthorized distributor."

"Excellent inventory, authorized distributor and competitive pricing."

Do not repeat numerical values.

---

# Validation Rules

Before generating the output, validate that:

✓ Every supplier has all five individual risk scores.

✓ Overall Risk Score is calculated using the weighted formula.

✓ Final score is between 0 and 10.

✓ Risk Level matches the score.

✓ Risk Reason matches the highest contributing risk factors.

---

# HTML Design Requirements

Return ONLY HTML.

Generate a modern professional procurement dashboard table.

The table must occupy 100% width.

Use border-collapse.

Use Arial or Segoe UI font.

Header Background

Dark Blue (#1F4E79)

Header Text

White

Header Font

Bold

Cell Padding

10px

Alternate row colors

White

Light Gray (#F8FAFC)

Center-align all numeric columns.

Left-align Supplier Name and Reason.

Overall Risk Score should be bold.

---

# Conditional Formatting

Risk Score

0.0 – 2.0

Green background

Dark Green text

2.1 – 4.0

Light Green background

Green text

4.1 – 6.0

Light Orange background

Dark Orange text

6.1 – 8.0

Light Red background

Dark Red text

8.1 – 10.0

Dark Red background

White text

---

# Risk Icons

Very Low Risk

🟢

Low Risk

🟢

Medium Risk

🟡

High Risk

🟠

Critical Risk

🔴

Display the icon before the Risk Level.

---

# Table Columns

Supplier Name

Inventory Risk

Lead Time Risk

Authorization Risk

Price Risk

Geographic Risk

Overall Risk Score

Risk Level

Risk Reason

---

# Final Output

Return ONLY valid HTML.

Do not return Markdown.

Do not return explanations.

Do not include any text before or after the HTML.

Generate a clean, enterprise-grade procurement dashboard suitable for an Aerospace & Defense or EMS sourcing platform.`;

        const currencyConversionRates: { [key: string]: number } = {
          INR: 1,
          USD: 86,
          EUR: 90
        };


        this.filteredSourceInfoData = this.filteredSourceInfoData.map((item: any) => {
          const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);


          const basePriceINR = (item.Price || 0) * (item.ConversionRate || 1);


          const landingCostINR = item.LandingCost || 0;
          const totalLandingCost = (landingCostINR / (item.ConversionRate || 1)) * qty;

          // Total Est Landing Cost
          const totalEstCost = landingCostINR * qty;

          return {
            ...item,
            BasePriceINR: basePriceINR,
            LandingCost: landingCostINR,
            Total_est_Cost: totalEstCost,
            Total_landing_cost: totalLandingCost

          };
        });


        let manufacturer: any = [];
        for (let index = 0; index < this.sourceInfoData.length; index++) {
          manufacturer.push(this.sourceInfoData[index]['manufacturer']);
          this.manufacturerDetails = manufacturer;
          this.manufacturerDetails = Array.from(new Set(manufacturer));

        }

        // Carry on with your existing risk analysis, calculations and other logic as needed...

        console.log('this.projectViewData', this.projectViewData);
      } else {
        console.error('Error: No data available for project');
        this.errorMessage = 'No data available for this part. Please try again.';
        if (!this.fromPoHistory) {
          this.notify.danger('No data available for this part', 'Error');
        }
      }
    }, error => {
      this.isLoading = false;
      console.error('Error retrieving project data:', error);
      this.errorMessage = 'Failed to retrieve project data. Please try again.';
      this.notify.danger('Failed to retrieve project data', 'Error');
    });
  }
  calculateLandingCosts(data: any[]) {
    return data.map((item: any) => {
      const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);

      const conversionRate = item.ConversionRate || 1;
      const landingCostINR = item.LandingCost || 0;

      return {
        ...item,
        BasePriceINR: (item.Price || 0) * conversionRate,
        Total_est_Cost: landingCostINR * qty,
        Total_landing_cost: (landingCostINR / conversionRate) * qty
      };
    });
  }

  openDatasheet(supplierData: any) {
    // Use the datasheetURL or clickUrl field; fallback to null check
    const url = supplierData.DatasheetURL;
    if (url) {
      window.open(url, '_blank');
    } else {
      console.warn('No datasheet URL available for supplier:', supplierData.supplier);
    }
  }

  callAnalyzeHtml() {
    if (!this.preparedPartDetails.length || !this.preparedQuery) {
      console.error('Analyze HTML payload not ready.');
      return;
    }

    const payload = {
      data: this.preparedPartDetails,
      query: this.preparedQuery
    };

    this.isLoading = true;
    this.loadingTitle = 'Generating Risk Assessment';
    this.loadingSubtitle = 'Analyzing supplier risk scores, lead time, and price variance...';
    this.masterService.analyze_html(payload).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.cleanedResHTML = res?.html?.replace(/\n/g, '') || '';
        this.showPopup = true;

        setTimeout(() => {
          const container = document.querySelector('#risk-analysis-table');
          const table = container?.querySelector('table');

          if (!table) return;

          const rows = table.querySelectorAll('tbody tr');
          rows.forEach((row: any) => {
            const cells = row.querySelectorAll('td');
            if (cells.length > 1) {
              const scoreCell = cells[1]; // "Total Risk Score" column
              const score = parseFloat(scoreCell.innerText);
              if (!isNaN(score)) {
                const dot = document.createElement('span');
                dot.style.display = 'inline-block';
                dot.style.width = '10px';
                dot.style.height = '10px';
                dot.style.borderRadius = '50%';
                dot.style.marginLeft = '8px';
                dot.style.verticalAlign = 'middle';

                if (score < 4) {
                  dot.style.backgroundColor = 'green';
                } else if (score <= 5.5) {
                  dot.style.backgroundColor = 'orange';
                } else {
                  dot.style.backgroundColor = 'red';
                }

                dot.title = `Risk Score: ${score}`;
                scoreCell.appendChild(dot);

                scoreCell.style.backgroundColor = 'transparent';
                scoreCell.style.color = 'black';
              }
            }
          });
        }, 100);

      },
      error => {
        this.isLoading = false;
        console.error('analyze_html API error:', error);
      }
    );
  }


  onCardClick() {
    // this.cleanedResHTML = '';  
    this.callAnalyzeHtml();
    this.showPopup = true;
    // this.Indicator();
  }

  closePopup() {
    this.showPopup = false;
  }

  onAlternateClick() {
    // Find the finalized row
    const finalizedRow = this.filteredSourceInfoData.find(row => row.Isfinalized === true);

    if (!finalizedRow) {
      this.notify.warning('No finalized supplier found. Please finalize a supplier first.');
      return;
    }

    // Use the finalized row data
    this.onClickAlternatives(finalizedRow);
  }

  refreshPage() {
    this.selectedManufacturer = '';
    this.mpnMatch = this.sessionMpnMatch;
    this.getdata();
  }

  openDataSheet() {
    if (this.dataSheet) {
      window.open(this.dataSheet, '_blank'); // Opens in a new tab
    }
  }

  home() {

    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }

  back() {
    console.log("Sending Back Filter From Part-Info:", this.savedFilter);
    console.log("Sending Back Tab Index From Part-Info:", history.state?.selectedTabIndex);
    if (this.userRole === 'Engineer') {
      let state: any = history.state
      this.router.navigate(['/project-view'], {
        state: {

          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,
          customerInfo: this.customerInfoData,
          detectPartInfo: true,
          savedFilter: this.savedFilter,
          selectedTabIndex: state?.selectedTabIndex ?? 0
        }
      })
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      let state: any = history.state
      this.router.navigate(['/project-view'], {
        state: {
          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,
          customerInfo: this.customerInfoData,
          detectPartInfo: true,
          savedFilter: this.savedFilter,
          selectedTabIndex: state?.selectedTabIndex ?? 0
        }
      })
    }
  }


  onManufacturerChange() {

    const currencyConversionRates: { [key: string]: number } = {
      INR: 1,
      USD: 86,
      EUR: 90
    };

    let filteredData: any[] = [];

    if (this.selectedManufacturer) {
      filteredData = this.sourceInfoData.filter(
        (item: any) => item.manufacturer === this.selectedManufacturer
      );

      this.mpnMatch = filteredData.length > 0 ? filteredData[0].MPN : 'N/A';
    } else {
      filteredData = [...this.sourceInfoData];
      this.mpnMatch = '';
    }

    //  IMPORTANT: Recalculate Landing Cost & Totals after filter
    this.filteredSourceInfoData = filteredData.map((item: any) => {
      const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);
      const conversionRate = item.ConversionRate || 1;
      const landingCostINR = item.LandingCost || 0;

      return {
        ...item,
        BasePriceINR: (item.Price || 0) * conversionRate,
        Total_est_Cost: landingCostINR * qty,
        Total_landing_cost: (landingCostINR / conversionRate) * qty
      };
    });
  }

  exportData(): void {
    this.exportService.exportToExcel(this.filteredSourceInfoData, `${this.internalPartNo}-PartInfo.xlsx`, `${this.internalPartNo}-PartInfo`);
  }

  selectRow(index: number) {
    this.selectedRowIndex = this.selectedRowIndex === index ? null : index; // Toggle selection
  }

  onClickOfferPrice(offerPriceModal: any, selectedData: any) {
    this.offerPriceListDetails = [];
    this.selectedSupplierData = null;

    if (selectedData.sourcingType === 'offline') {
      this.tempOfflineData = { ...selectedData };
      this.offlineConfirmModalRef = this.modalService.open(this.offlineConfirmModal, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        centered: true,
        backdrop: 'static'
      });
      return;
    }

    this.modalRef = this.modalService.open(offerPriceModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: true,
      windowClass: 'op-custom-modal'
    });

    const requestData = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
      projectQty: this.projectQty,
      specification: selectedData.specification,
      MPN: selectedData.MPN,
      manufacturer: selectedData.manufacturer,
      supplier: selectedData.supplier,
      source: selectedData.sourcingType,
      MOQ: selectedData.MOQ ?? selectedData.moq,
    };

    // keep local reference to avoid override by out-of-order responses
    const clickedMPN = selectedData.MPN;

    this.masterService.get_offer_price(requestData).subscribe(
      (result) => {
        // if user already clicked another row, ignore this response
        if (!this.modalRef || clickedMPN !== selectedData.MPN) {
          return;
        }

        const responseData = result['results']?.[0];

        if (responseData) {
          this.offerPriceListDetails = responseData.prices || [];
          const currency = responseData.prices?.[0]?.currency;

          this.selectedSupplierData = {
            ...selectedData,
            companyName: responseData.companyName,
            stored_at: responseData.stored_at,
            currency: currency,
            unitOfMeasure: responseData.unitOfMeasure ?? responseData.UnitOfMeasure ?? responseData.uom,
            LandingCost: selectedData.LandingCost
          };
        } else {
          this.offerPriceListDetails = [];
        }
      },
      (error) => {
        console.error('Error fetching offer price:', error);
        this.notify.danger('Failed to fetch offer price', 'Error');
        this.offerPriceListDetails = [];
      }
    );
  }


  confirmOfflineUpdate() {
    if (this.isReviewStage) {
      this.notify.warning("Updating finalized supplier is not allowed when the project is in the review stage.");
      return;
    }
    // Close confirmation modal
    if (this.offlineConfirmModalRef) {
      this.offlineConfirmModalRef.close();
    }

    // Prepare data from tempOfflineData
    this.selectedSupplierData = {
      ...this.tempOfflineData,
      companyName: this.tempOfflineData.supplier || '',
      stored_at: new Date().toISOString(),
      currency: this.tempOfflineData.Currency || 'INR',
      LandingCost: this.tempOfflineData.LandingCost
    };

    // Prepare selectedPriceData with offline data
    this.selectedPriceData = {
      quantity: this.tempOfflineData.Closest_Quantity || this.tempOfflineData.MOQ || 0,
      price: this.tempOfflineData.Price || 0,
      currency: this.tempOfflineData.Currency || 'INR'
    };


    this.savePriceDataOffline();

    // Clear temp data
    this.tempOfflineData = null;
  }



  // selectPriceRow(index: number) {
  //   this.selectedPriceRowIndex = this.selectedPriceRowIndex === index ? null : index; // Toggle selection
  //   this.selectedPriceData = this.offerPriceListDetails[index]; // Store the selected object

  //   console.log('offerPriceDetails', this.selectedPriceData)
  // }

  selectPriceRow(index: number) {

    if (this.selectedPriceRowIndex === index) {
      this.selectedPriceRowIndex = null;
      this.selectedPriceData = null;
    } else {
      this.selectedPriceRowIndex = index;
      this.selectedPriceData = this.offerPriceListDetails[index];
    }
  }




  savePriceData() {
    if (this.isReviewStage) {
      this.notify.warning("Updating finalized supplier is not allowed when the project is in the review stage.");
      return;
    }
    console.log("this.selectedSupplierData => ", this.selectedSupplierData);

    let obj = {
      "project_id": Number(this.project_id),
      "version_id": Number(this.version_id),
      "procurement_version_id": this.customerInfoData?.procurement_version_id ?? 0,
      "MPN": this.selectedSupplierData.MPN,
      "Inventorylevel": this.selectedSupplierData.Inventorylevel,
      "estimatedFactoryLeadDays": this.selectedSupplierData.estimatedFactoryLeadDays,
      "MOQ": this.selectedSupplierData.MOQ ? this.selectedSupplierData.MOQ : this.selectedPriceData.quantity,
      "TotalAvail": this.selectedSupplierData.TotalAvail,
      "Closest_Quantity": this.selectedPriceData.quantity,
      "Price": this.selectedPriceData.price,
      "Currency": this.selectedPriceData.currency,
      "country": this.selectedSupplierData.country,
      "ConvertedCurrency": this.selectedSupplierData.ConvertedCurrency || "INR",
      "ConversionRate": this.selectedSupplierData.ConversionRate,
      "ConvertedPrice": this.selectedSupplierData.ConvertedPrice,
      // "Manufacturer_ID": this.selectedSupplierData.Manufacturer_ID,
      "Manufacturer_ID": this.selectedSupplierData.Manufacturer_ID || "",
      "manufacturer": this.selectedSupplierData.manufacturer,
      "supplier": this.selectedSupplierData.supplier,
      "Seller_ID": this.selectedSupplierData.Seller_ID,
      "Manufacturer_IsVerified": this.selectedSupplierData.Manufacturer_IsVerified,
      "DatasheetURL": this.selectedSupplierData?.DatasheetURL || "",
      "QuantityDiff": this.selectedSupplierData.QuantityDiff,
      "Rank_id": this.selectedSupplierData.Rank,
      "BestSeller": "Yes",
      "stockAvailability": this.selectedSupplierData.Inventorylevel,
      "internalPartNo": sessionStorage.getItem('internalPartNo'),
      "landing_cost": Math.round(this.selectedSupplierData?.LandingCost ?? 0),
      "Total_cost": this.selectedSupplierData.Total_cost,
      "IsSourced": 1,
      "sourcingType": this.selectedSupplierData.sourcingType || 'nexar'
    };

    console.log("Savepayload => ", obj);

    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);

        // Close modal only if it was opened (for nexar/vendor)
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();

        // Show success notification
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        console.log("✓ Saving price data and returning with Tab Index:", state?.selectedTabIndex ?? 0);
        // Navigate back to project view
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            selectedTabIndex: state?.selectedTabIndex ?? 0,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
            savedFilter: this.savedFilter || 'all'
          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );
  }
  savePriceDataOffline() {
    if (this.isReviewStage) {
      this.notify.warning("Updating finalized supplier is not allowed when the project is in the review stage.");
      return;
    }
    if (!this.selectedPriceData || !this.selectedSupplierData) {
      console.error("No selected data found to save.");
      return;
    }

    const qty = Number(this.selectedPriceData.quantity) || 1;
    const price = Number(this.selectedPriceData.price) || 0;


    let obj = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
      MPN: this.selectedSupplierData.MPN || "",
      supplier: this.selectedSupplierData.supplier || "",
      Currency: this.selectedPriceData.currency || 'INR',
      MOQ: this.selectedSupplierData.MOQ,
      Closest_Quantity: this.selectedSupplierData.Closest_Quantity,
      Price: price,
      landing_cost: Math.round(this.selectedSupplierData?.LandingCost ?? 0),
      Total_cost: this.selectedSupplierData.Total_cost,
      internalPartNo: this.internalPartNo || "",
      Inventorylevel: 0,
      estimatedFactoryLeadDays: Number(this.selectedSupplierData.estimatedFactoryLeadDays).toFixed(2),
      TotalAvail: 0,
      country: "IN",
      ConvertedCurrency: this.selectedSupplierData.ConvertedCurrency || "INR",
      ConversionRate: this.selectedSupplierData.ConversionRate,
      ConvertedPrice: Number(this.selectedSupplierData.ConvertedPrice).toFixed(2),
      Manufacturer_ID: "0",
      manufacturer: this.selectedSupplierData.manufacturer,
      Seller_ID: "0",
      Manufacturer_IsVerified: true,
      DatasheetURL: "",
      QuantityDiff: 0,
      Rank_id: 0,
      BestSeller: "Yes",
      stockAvailability: 0,
      "IsSourced": 1,
      sourcingType: this.selectedSupplierData.sourcingType || 'offline'
    };

    console.log("Save payload => ", obj);
    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();
        let customerInfo: any = structuredClone(this.customerInfoData);
        console.log("customerInfo => ", customerInfo);
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        console.log("✓ Saving offline data and returning with Tab Index:", state?.selectedTabIndex ?? 0);
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            selectedTabIndex: state?.selectedTabIndex ?? 0,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
            savedFilter: this.savedFilter || 'all'
          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );

  }



  savePriceDataPriceHistory() {
    if (!this.selectedPriceData || !this.selectedSupplierData) {
      console.error("No selected data found to save.");
      return;
    }

    const qty = Number(this.selectedPriceData.quantity) || 1;
    const price = Number(this.selectedPriceData.price) || 0;
    const convertedPrice = Number(this.selectedPriceData.convertedPrice) || 0;
    const landingCost = Number(this.selectedPriceData.landing_INR_cost) || 0;
    const TotalCost = Number(this.selectedPriceData.Total_cost) || 0;
    let obj = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
      MPN: this.selectedSupplierData.MPN || "",
      supplier: this.selectedSupplierData.supplier || "",
      Currency: this.selectedPriceData.currency || 'INR',
      MOQ: 1,
      Closest_Quantity: 1,
      Price: price,
      landing_cost: Math.round(landingCost),
      Total_cost: TotalCost,
      internalPartNo: this.internalPartNo || "",
      Inventorylevel: 0,
      estimatedFactoryLeadDays: 42,
      TotalAvail: 0,
      country: "IN",
      ConvertedCurrency: "INR",
      ConversionRate: 0,
      ConvertedPrice: convertedPrice,
      Manufacturer_ID: "0",
      manufacturer: "No Info",
      Seller_ID: "0",
      Manufacturer_IsVerified: true,
      DatasheetURL: "",
      QuantityDiff: 0,
      Rank_id: 0,
      BestSeller: "Yes",
      stockAvailability: 0,
      "IsSourced": 1,
      sourcingType: this.selectedSupplierData.sourcingType || 'offline'
    };

    console.log("Save payload => ", obj);

    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);

        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();
        let customerInfo: any = structuredClone(this.customerInfoData);
        console.log("customerInfo => ", customerInfo);
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        console.log("✓ Saving price history and returning with Tab Index:", state?.selectedTabIndex ?? 0);
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            selectedTabIndex: state?.selectedTabIndex ?? 0,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
            savedFilter: this.savedFilter || 'all'
          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );
  }

  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
    }
    this.modalService.dismissAll();
  }
  getUnitsName(specs: any[], specName: string): string {
    const spec = specs?.find(s => s.name === specName);
    return spec?.unitsName || '';
  }
  selectCriteria(criteriaModal: any) {
    console.log('Criteria selected');

    this.modalRef = this.modalService.open(criteriaModal, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: 'criteria-modal-popup' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openSourcingModal(sourcingModal: any): void {
    this.isLoadingIpnInfo = true;
    this.ipnInfoRelationships = [];
    this.ipnInfoMpnCount = 0;
    this.ipnInfoMfgCount = 0;

    this.modalRef = this.modalService.open(sourcingModal, {
      centered: true,
      backdrop: 'static',
      windowClass: 'sourcing-relationships-modal'
    });

    const projId = Number(this.project_id);
    const verId = Number(this.version_id);
    const procId = 0;

    if (projId && verId) {
      this.masterService.getInputSourceDropdown(projId, verId, procId).subscribe({
        next: (res: any) => {
          this.isLoadingIpnInfo = false;
          const relations = res?.relationships || [];
          const currentIpn = String(this.internalPartNo || '').trim().toLowerCase();
          this.ipnInfoRelationships = relations.filter(
            (r: any) => String(r.internal_part_numbers || '').trim().toLowerCase() === currentIpn
          );

          const uniqueMpns = new Set(this.ipnInfoRelationships.map((r: any) => r.specification).filter(Boolean));
          const uniqueMfgs = new Set(this.ipnInfoRelationships.map((r: any) => r.manufacturer).filter(Boolean));

          this.ipnInfoMpnCount = uniqueMpns.size;
          this.ipnInfoMfgCount = uniqueMfgs.size;
        },
        error: (err: any) => {
          console.error("Error fetching input source dropdown options:", err);
          this.isLoadingIpnInfo = false;
          this.ipnInfoRelationships = [];
          this.ipnInfoMpnCount = 0;
          this.ipnInfoMfgCount = 0;
        }
      });
    } else {
      this.isLoadingIpnInfo = false;
    }
  }



  hasValue(val: any): boolean {
    return val !== null && val !== undefined && val !== '' && val !== 'null' && val !== 'undefined';
  }

  getPricingDetails(data: any): { label: string; value: any; icon?: string; fullWidth?: boolean }[] {
    return this.getStandardPricingDetails(data);
  }

  getStandardPricingDetails(data: any): { label: string; value: any; icon?: string }[] {
    if (!data) return [];
    const items: { label: string; value: any; icon?: string }[] = [];

    const addIfPresent = (label: string, value: any, icon: string) => {
      if (this.hasValue(value)) {
        items.push({ label, value, icon });
      }
    };

    addIfPresent('Factory Pack Qty', data.factoryPackQuantity ?? data.FactoryPackQuantity, 'fas fa-boxes');
    addIfPresent('On Order Qty', data.onOrderQuantity ?? data.OnOrderQuantity, 'fas fa-truck-loading');

    const attrName = data['Attribute name'] || data['Attribute Name'] || data.attributeName || data.AttributeName;
    addIfPresent('Attribute Name', attrName, 'fas fa-sliders-h');

    addIfPresent('Tube', data.Tube || data.tube, 'fas fa-box-open');
    addIfPresent('Package', data.Package || data.package || data.Packaging || data.packaging, 'fas fa-cube');
    addIfPresent('Unit of Measure', data.unitOfMeasure || data.UnitOfMeasure || data.uom, 'fas fa-ruler-combined');

    return items;
  }

  getDescriptionPricingDetails(data: any): { label: string; value: any; icon: string; type: 'short' | 'detailed' }[] {
    if (!data) return [];
    const items: { label: string; value: any; icon: string; type: 'short' | 'detailed' }[] = [];

    const shortDesc = data.ShortDescription || data.shortDescription;
    if (this.hasValue(shortDesc)) {
      items.push({ label: 'Short Description', value: shortDesc, icon: 'fas fa-align-left', type: 'short' });
    }

    const detailedDesc = data.DetailedDescription || data.detailedDescription;
    if (this.hasValue(detailedDesc)) {
      items.push({ label: 'Detailed Description', value: detailedDesc, icon: 'fas fa-file-alt', type: 'detailed' });
    }

    return items;
  }

  hasDescriptionDetails(data: any): boolean {
    return this.getDescriptionPricingDetails(data).length > 0;
  }

  hasTechSpecs(data: any): boolean {
    if (!data) return false;
    const techSpecKeys = [
      'Tariff', 'tariff',
      'LifecycleStatus', 'lifecycleStatus',
      'EndOfLife', 'endOfLife',
      'Discontinued', 'discontinued',
      'Ncnr', 'ncnr', 'NCNR',
      'countryOfOrigin', 'CountryOfOrigin', 'coo',
      'releaseStatusCode', 'ReleaseStatusCode',
      'rohsStatusCode', 'RohsStatusCode', 'rohs'
    ];
    return techSpecKeys.some(key => this.hasValue(data[key]));
  }

  specificationDetails(partDetails: any) {
    this.selectedPart = partDetails ? {
      ...partDetails,
      MPN: partDetails?.MPN || partDetails?.partNumber || partDetails?.PartNumber || '',
      manufacturer: partDetails?.manufacturer || partDetails?.Make || partDetails?.make || ''
    } : null;

    let specs: any[] = Array.isArray(partDetails?.Specs) ? [...partDetails.Specs] : [];

    // Filter out Description from specs table array if present
    specs = specs.filter(s => s?.name?.toLowerCase() !== 'description');

    if (partDetails) {
      const techSpecFields = [
        { key: 'Tariff', label: 'Tariff', altKeys: ['tariff'] },
        { key: 'LifecycleStatus', label: 'Lifecycle Status', altKeys: ['lifecycleStatus'] },
        { key: 'EndOfLife', label: 'End of Life', altKeys: ['endOfLife'] },
        { key: 'Discontinued', label: 'Discontinued', altKeys: ['discontinued'] },
        { key: 'Ncnr', label: 'NCNR', altKeys: ['ncnr', 'NCNR'] },
        { key: 'countryOfOrigin', label: 'Country of Origin', altKeys: ['CountryOfOrigin', 'coo'] },
        { key: 'releaseStatusCode', label: 'Release Status Code', altKeys: ['ReleaseStatusCode'] },
        { key: 'rohsStatusCode', label: 'RoHS Status Code', altKeys: ['RohsStatusCode', 'rohs'] }
      ];

      techSpecFields.forEach(field => {
        let val = partDetails[field.key];
        if (!this.hasValue(val) && field.altKeys) {
          for (const altKey of field.altKeys) {
            if (this.hasValue(partDetails[altKey])) {
              val = partDetails[altKey];
              break;
            }
          }
        }

        if (this.hasValue(val)) {
          const exists = specs.some(s =>
            s?.name?.toLowerCase() === field.label.toLowerCase() ||
            s?.name?.toLowerCase() === field.key.toLowerCase()
          );

          if (!exists) {
            specs.push({
              name: field.label,
              value: val,
              group: 'Technical Specs'
            });
          }
        }
      });
    }

    this.selectedSpecs = specs;
    this.showSpecsDetails = true;
  }

  closeSpecificationDetails() {
    this.showSpecsDetails = false;
    this.selectedSpecs = [];
    this.selectedPart = null;
  }

  onClickAlternatives(data: any) {
    if (!data?.MPN) {
      this.notify.warning('MPN information is missing');
      return;
    }

    // Build payload - include manufacturer only if finalized
    const payload = {
      mpn: data.MPN,
      manufacturer: data.Isfinalized ? data.manufacturer : ''
    };

    this.masterService.mpnCheck(payload).subscribe(
      (response: any) => {
        this.alternativesData = response;
        this.selectedPartForAlternatives = data;
        this.showAlternativesPopup = true;
      },
      (error: any) => {
        console.error('Error fetching alternatives:', error);
        this.notify.danger('Error fetching alternatives. Please try again.');
      }
    );
  }

  closeAlternativesPopup() {
    this.showAlternativesPopup = false;
    this.alternativesData = null;
    this.selectedPartForAlternatives = null;
  }

  priceSummary: any;
  selectedPriceHistory: any[] = [];

  closePriceHistory() {
    this.showPopup1 = false;

    let state: any = history.state

    if (this.cameFrom === 'project-view') {
      this.router.navigate(
        ['/project-view'],
        {
          state: {
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state?.rowsPerPage ?? 10,
            currentPage: state?.currentPage ?? 1,
            selectedTabIndex: state?.selectedTabIndex ?? 0,
            savedFilter: this.savedFilter || 'all'
          }
        }
      );
    }
  }



  getProcurementHistory() {
    if (!this.internalPartNo) {
      console.error("Internal Part Number not found in sessionStorage");
      return;
    }

    this.masterService.getPartPriceHistoryInternal(
      this.internalPartNo,
      this.project_id,
      this.version_id,
      this.commodity,
      this.customerInfoData?.procurement_version_id ?? 0
    ).subscribe({
      next: (response: any) => {

        if (!response || !response.parts || response.parts.length === 0) {
          this.infoMessage = 'Procurement history not available';
          this.showPopup1 = false;
          return;
        }
        this.priceSummary = {
          internalPartNumber: response.internalPartNumber,
          minPriceINR: response.minLandingPriceINR,
          maxPriceINR: response.maxLandingPriceINR,
          purchaseCount: response.purchaseCount,
          weightedAveragePriceINR: response.weightedAveragePriceINR,
          projectQty: this.projectQty
        };

        this.selectedPriceHistory = response.parts;
        console.log("Selected Price History:", this.selectedPriceHistory);
        this.infoMessage = '';
        this.showPopup1 = true;
      },
      error: (err) => {
        console.error('Error fetching price history', err);
        this.showPopup1 = false;
        this.showInfoToast('Procurement history not available');
      }
    });
  }
  infoMessage: string = '';

  showInfoToast(message: string) {
    this.notify.info(message);
  }

  selectedHistory: any[] = [];
  showSendButton: boolean = false;



  // onSelectHistory(selectedRow: any) {

  //   // Unselect all rows first
  //   this.selectedPriceHistory.forEach(r => {
  //     if (r !== selectedRow) {
  //       r.isSelected = false;
  //     }
  //   });

  //   // Toggle the clicked row ON
  //   selectedRow.isSelected = true;

  //   // Store only that one row
  //   this.selectedHistory = [selectedRow];

  //   // Show button
  //   this.showSendButton = true;
  // }

  onSelectHistory(selectedRow: any) {

    if (selectedRow.isSelected) {

      this.selectedPriceHistory.forEach(r => {
        if (r !== selectedRow) {
          r.isSelected = false;
        }
      });

      this.selectedHistory = [selectedRow];

      this.showSendButton = true;

    } else {
      this.selectedHistory = [];
      this.showSendButton = false;
    }
  }

  sendSelectedHistory() {
    if (this.isReviewStage) {
      this.notify.warning("Updating finalized supplier is not allowed when the project is in the review stage.");
      return;
    }
    if (!this.selectedHistory || this.selectedHistory.length === 0) {
      return;
    }

    const selectedRow = this.selectedHistory[this.selectedHistory.length - 1];

    this.selectedSupplierData = {
      supplier: selectedRow.supplierName,
      MPN: selectedRow.mpn,
      ConvertedCurrency: selectedRow.currency || 'INR',
      sourcingType: 'offline'
    };

    // Assign values to selectedPriceData
    this.selectedPriceData = {
      quantity: selectedRow.qty,
      price: selectedRow.unitPrice,
      currency: selectedRow.currency || 'INR',
      convertedPrice: selectedRow.unitPriceINR,
      landing_INR_cost: selectedRow.landing_INR_cost

    };
    this.showPopup1 = false;

    // Call your existing save
    this.savePriceDataPriceHistory();
  }



  onSort(column: string) {
    if (this.sortColumn === column) {

      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.selectedPriceHistory.sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }


}
